import { IDs } from '../../helpers/IDs';

export function getSystemparameter(data: any, paramkey: string) {
    const sysParams: Array<any> = data[IDs.ENT_SYSTEMPARAMETER] || [];
    const fnd = sysParams.find((p: any) => p.parameter === paramkey);
    if (fnd) {
        return fnd.wert;
    }
    return undefined;
}